
import * as imgixRuntime$Sy8_MsaPOzsOsa0Dk_4544O4oSVNxt1DzsSmydiaH01nU from '/home/runner/_work/monorepo/monorepo/frontend/marketplace/node_modules/@nuxt/image/dist/runtime/providers/imgix'
import * as noneRuntime$HylrMkTjHMZKQBSof3TyKEIzGLbIMjFhmEVQptgdEF0 from '/home/runner/_work/monorepo/monorepo/frontend/marketplace/node_modules/@nuxt/image/dist/runtime/providers/none'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536,
    "3xl": 1600,
    "4xl": 1920,
    "5xl": 2400
  },
  "presets": {
    "simpleFormatAndCompression": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ]
      }
    },
    "productCard": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "width": 375,
        "height": 375,
        "fit": "contain"
      }
    },
    "productGallery": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "width": 300,
        "height": 300,
        "fit": "contain"
      }
    },
    "productHighlight": {
      "modifiers": {
        "auto": [
          "format"
        ],
        "width": 960,
        "height": 960,
        "fit": "contain"
      }
    },
    "productTouchZoom": {
      "modifiers": {
        "auto": [
          "format"
        ],
        "width": 1600,
        "height": 1600,
        "fit": "contain"
      }
    },
    "newsArticle": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "width": 1000,
        "height": 500,
        "fit": "contain"
      }
    },
    "banner": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "width": 1920,
        "height": 500,
        "fit": "cover",
        "q": "80"
      }
    },
    "eventBanner": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "width": 2100,
        "height": 1000,
        "fit": "cover"
      }
    },
    "highlightedNewsCard": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "width": 1600,
        "height": 1000,
        "fit": "cover"
      }
    },
    "categoryBannerMobile": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "ar": "210:148",
        "fit": "cover"
      }
    },
    "categoryBannerDesktop": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "ar": "21:8",
        "fit": "cover"
      }
    },
    "squareBannerImage": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "ar": "1:1",
        "fit": "cover"
      }
    },
    "fullWidthBlockDesktopLarge": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "ar": "2:1",
        "fit": "cover"
      }
    },
    "fullWidthBlockDesktopSmall": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "ar": "4:1",
        "fit": "cover"
      }
    },
    "callToActionBannerMobile": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "ar": "2100:1726",
        "fit": "cover"
      }
    },
    "callToActionBannerTablet": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "ar": "210:100",
        "fit": "cover"
      }
    },
    "callToActionBannerDesktop": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "ar": "210:120",
        "fit": "cover"
      }
    },
    "teamCardBanner": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "width": 128,
        "height": 128,
        "fit": "cover"
      }
    },
    "eventCardBanner": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "width": 960,
        "height": 480,
        "fit": "cover",
        "crop": "faces"
      }
    },
    "logoLarge": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "width": 256,
        "height": 256,
        "fit": "fit"
      }
    },
    "logoMedium": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "width": 128,
        "height": 128,
        "fit": "fit"
      }
    },
    "logoSmall": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "width": 64,
        "height": 64,
        "fit": "fit"
      }
    },
    "logoExtraSmall": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "width": 32,
        "height": 32,
        "fit": "fit"
      }
    },
    "card": {
      "modifiers": {
        "auto": [
          "format",
          "compress"
        ],
        "height": 1000,
        "fit": "cover"
      }
    }
  },
  "provider": "none",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['imgix']: { provider: imgixRuntime$Sy8_MsaPOzsOsa0Dk_4544O4oSVNxt1DzsSmydiaH01nU, defaults: {"baseURL":""} },
  ['none']: { provider: noneRuntime$HylrMkTjHMZKQBSof3TyKEIzGLbIMjFhmEVQptgdEF0, defaults: {} }
}
        